import { PairedLinesTypes } from '../action/index.model'
import { PairedLine } from './index.model'

const initialState: PairedLine = {
  loading: false,
  language: '',
  toastMessage: false,
  noofAttempts: 0,
  msisdn: '',
  longRunningQuery: false,
  error: '',
}

const PairLinesReducer: any = (state: PairedLine = initialState, action: any) => {
  switch (action.type) {
    case PairedLinesTypes.SET_PAIRED_LINE:
      return {
        ...state,
        msisdn: action.data.msisdn,
      }
    case PairedLinesTypes.RESET_PAIRED_LINE:
      return {
        ...initialState,
      }
    case PairedLinesTypes.SET_LOADER:
      return {
        ...state,
        loading: action.data,
        error: '',
      }
    case PairedLinesTypes.SET_ERROR:
      return {
        ...state,
        loading: false,
        error: action.data,
      }
    case PairedLinesTypes.SET_ATTEMPTS:
      return {
        ...state,
        noofAttempts: action.data,
      }
    default:
      return state
  }
}
export default PairLinesReducer
